// src/services/attendanceService.js
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ; // || 'http://localhost:3030';

const api = axios.create({
  baseURL: API_BASE_URL,
});

/**
 * Get current attendance status
 * @param {string} accessToken - MSAL/JWT access token
 */
export const getStatus = (accessToken) => {
  return api.get("/api/attendances/status", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json', 
    },
  }).then(res => res.data);
};

/**
 * Check-in attendance
 * @param {string} accessToken - MSAL/JWT access token
 * @param {object} employeeData - mandatory payload; must pass { latitude, longitude, accuracy }
 */
export const checkIn = (accessToken, employeeData) => {
  return api.post("/api/attendances/check-in", employeeData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then(res => res.data);
};


/**
 * Check-out attendance
 * @param {string} accessToken - MSAL/JWT access token
 * @param {object} locationData - mandatory { latitude, longitude, accuracy }
 */
export const checkOut = (accessToken, locationData) => {
  return api.post("/api/attendances/check-out", locationData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then(res => res.data);
};

export default { getStatus, checkIn, checkOut };
